<template>
  <div class="submit-form-container">
    <div class="submitting" v-if="isSubmitting">
      {{ labels.get("Submitting") }}
    </div>
    <div class="submitted" v-if="hasSubmitted">
      {{ labels.get("Submitted") }}
    </div>
    <div class="error" v-if="!!error">{{ error }}</div>
    <FlatButton class="submit-button" blue v-if="hasSubmitted & !!allowRestart" :label="labels.get('Restart')"
      @click="$emit('rewind')"></FlatButton>
    <FlatButton class="submit-button close-button" blue v-if="hasSubmitted & !allowRestart" :label="labels.get('Close')"
      @click="$emit('close')"></FlatButton>
    <FlatButton class="submit-button" blue v-if="error" :label="labels.get('Try again')" @click="$emit('back')">
    </FlatButton>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import { FlatButton } from "clariant-vue3-forms";

export default {
  name: "SubmitForm",
  components: {
    FlatButton,
  },
  props: {
    allowRestart: Boolean
  },
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      config: ServiceManager.getService(this, "Config"),
      state: ServiceManager.getService(this, "State"),
      utils: ServiceManager.getService(this, "Utils"),
      dataLayer: ServiceManager.getService(this, "DataLayer"),
      isSubmitting: false,
      hasSubmitted: false,
      error: "",
    };
  },
  mounted() {
    //this.state.subscribe(`${this.$options._componentTag}-${this._uid}`, this.onStateChanged);
  },
  beforeUnmount() {
    //this.state.unsubscribe(`${this.$options._componentTag}-${this._uid}`);
  },
  methods: {
    submitForm(payload) {
      if (!payload) return;
      this.error = "";
      this.isSubmitting = true;
      this.hasSubmitted = false;
      let loader = this.utils.showLoader(".submit-form-container");
      let postData = this.constructPostData(payload);
      this.dataLayer.submitForm(postData)
        .then((res) => {
          this.isSubmitting = false;
          this.hasSubmitted = true;
          this.reportToAnalytics(postData);
          if (typeof (customFormSubmissionHandler) !== "undefined") {
            console.info("Calling custom form submission handler.")
            customFormSubmissionHandler(postData);
          }
        })
        .catch((err) => {
          this.utils.showStatusMessage(
            `Could not load contact details. Error: ${err.message}.`,
            "red"
          );
          this.error = err.message;
        })
        .finally(() => {
          this.utils.removeLoader(loader);
        });
    },
    onRewind() {
      this.$emit("rewind");
      this.isSubmitting = false;
      this.hasSubmitted = false;
      this.error = "";
    },
    constructPostData(payload) {
      if (!payload) return null;
      let campaignData = (cla && cla.component && cla.component.analytics) ? cla.component.analytics.getCampaignData() : undefined;
      let ctxBuGuids = this.utils.toLongId(this.state.get("bu"));
      let ctxBuTags = "";
      let ctxBlGuids = "";
      let ctxBlTags = "";
      if (!ctxBuGuids) {
        //fallback
        ctxBuTags = this.getHiddenFieldValue("#pageBu");
        ctxBuGuids = this.getHiddenFieldValue("#pageBuId");
        ctxBlTags = this.getHiddenFieldValue("#pageBl");
        ctxBlGuids = this.getHiddenFieldValue("#pageBlId");
      }
      else {
        ctxBuTags = this.utils.idsToLabels(ctxBuGuids);
        ctxBlGuids = this.utils.toLongId(this.state.get("bl"));
        if (ctxBlGuids) ctxBlTags = this.utils.idsToLabels(ctxBlGuids);
      }

      return {
        salutation: payload.title,
        contactID: payload.contact.id,
        currentItemID: this.getHiddenFieldValue("#hidCurrentPageId"),
        firstName: payload.firstName,
        lastName: payload.lastName,
        email: payload.email,
        position: payload.jobTitle || "",
        company: payload.company || "",
        message: payload.message,
        topic: payload.requestType,
        hearAbout: "",
        address: this.getHiddenFieldValue("#address-contact-wizard"),
        postalCode: this.getHiddenFieldValue("#postal-code-contact-wizard"),
        context: window.location.href,
        cbNewsLetter: payload.ack2 ? "On" : "Off",
        phone: payload.phone || "",
        country: payload.country,
        buGuids: payload.contact.buGuids || "",
        buTags: payload.contact.buTags || "",
        blGuids: payload.contact.blGuids || "",
        blTags: payload.contact.blTags || "",
        contextBuGuids: ctxBuGuids,
        contextBuTags: ctxBuTags,
        contextBlGuids: ctxBlGuids,
        contextBlTags: ctxBlTags,
        campaignName: campaignData ? campaignData.name : "",
        campaignSource: campaignData ? campaignData.source : "",
        campaignMedium: campaignData ? campaignData.medium : "",
        campaignTerm: campaignData ? campaignData.term : "",
        campaignContent: campaignData ? campaignData.content : "",
        isCampaignLandingPage: campaignData ? campaignData.isLandingPage : false,
        jobTitle: payload.jobTitle || "",
        department: payload.department || "",
        companyType: payload.companyType || "",
        industry: payload.industry || "",
        application: payload.application || "",
      };
    },
    getHiddenFieldValue(sel) {
      let fld = document.querySelector(sel);
      if (fld) return fld.value;
      else return "";
    },
    reportToAnalytics(postData) {
      if (!cla || !cla.component || !cla.component.analytics) return;
      if (!postData) return;
      console.log(`Submitting contact form submission event to analytics.`);
      if (cla.component.analytics.submitCustomEvent) {
        cla.component.analytics.submitCustomEvent("Contact form submitted", {
          businessUnit: postData.buTags,
          businessLine: postData.blTags,
          pageBusinessUnit: postData.contextBuTags,
          pageBusinessLine: postData.contextBlTags
        });
      }
    }
  },
};
</script>

<style scoped>
.submit-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
}

.submit-button {
  margin-top: 100px;
}

.error {
  color: red;
}

.inline-contact-form-container .close-button {
  display: none;
}
</style>
